// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"229412ca","742":"49ce88d4","986":"29acb973"}[chunkId] + ".chunk.js";
};